// All assets are served from /assets/ (frontend/public/assets/).
// Fully self-contained — no external hosting dependencies.
const A = "/assets";

export const BUSINESS = {
  name: "KL Kárpitos",
  fullName: "Kovács László",
  phone: "+36 20 824 1269",
  phoneTel: "+36208241269",
  phoneDisplay: "06 20 824 1269",
  email: "strazsahegyi@gmail.com",
  area: "Monor + Pest megye · országos szállítás",
  logoUrl: `${A}/logo.png`,
};

// Curated set for the hero slideshow — strongest showcase pieces.
export const HERO_SLIDES = [
  `${A}/13.webp`, // Black chesterfield loveseat
  `${A}/14.webp`, // Restaurant/cafe grey booth
  `${A}/6.jpg`,
  `${A}/4.jpg`,
  `${A}/1.jpg`,
  `${A}/12.jpg`,
  `${A}/15.webp`, // Teal tufted benches
];

// Full gallery — recent work references.
export const GALLERY = [
  { src: `${A}/13.webp` },
  { src: `${A}/14.webp` },
  { src: `${A}/1.jpg` },
  { src: `${A}/2.jpg` },
  { src: `${A}/3.jpg` },
  { src: `${A}/4.jpg` },
  { src: `${A}/5.jpg` },
  { src: `${A}/6.jpg` },
  { src: `${A}/7.jpg` },
  { src: `${A}/9.jpg` },
  { src: `${A}/11.jpg` },
  { src: `${A}/12.jpg` },
  { src: `${A}/15.webp` },
  { src: `${A}/falvedo.png` }, // Falvédő
];

export const MATERIALS = [
  "Prémium bútorszövet",
  "Vízzel tisztítható / teflonos szövet",
  "Kültéri UV-álló szövet",
  "Bőr",
  "Műbőr",
  "Velúr",
  "Bársony",
  "Még nem tudom — kérek tanácsot",
];

export const WORK_LEVELS = [
  "Kisebb javítás / szövetcsere",
  "Részleges felújítás",
  "Teljes újrakárpitozás",
  "Egyedi elképzelés (éttermi, kávézói, ülőpad)",
  "Kerti bútor párnázata",
  "Falvédő / egyedi darab",
];

// Trust bullets — used in TrustBar and WhyChoose sections
export const TRUST_POINTS = [
  { icon: "Award", label: "Több éves tapasztalat" },
  { icon: "ShieldCheck", label: "Garanciával végzett munka" },
  { icon: "Sparkles", label: "Egyedi megoldások" },
  { icon: "Truck", label: "Háztól-házig szállítás" },
];

export const WHY_CHOOSE = [
  "Több éves szakmai tapasztalat",
  "Prémium minőségű alapanyagok",
  "Vízálló és UV-stabil kültéri szövetek",
  "Vízzel tisztítható, teflonos bútorszövetek",
  "Egyedi méretre készítés",
  "Garanciával végzett munka",
  "Saját szállítás az ország egész területén",
];
